import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { DetailsObjectType, EpisodeType } from 'store/pages/loaders/loader-types';
import { LIST_ITEMS_SIZE } from 'config';
import scaleSize from 'utils/scale-size';
import { FocusableParent } from 'components/navigation';
import ListItem, { LIST_ITEM_MARGIN } from 'components/CustomCollection/ListItem';
import Seasons from './Seasons';
import { StyledRecommendationsList } from './StyledComponents';

interface IExtraContentSection {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  seasons: any[]; // dont'know type yet
  recommendations: DetailsObjectType[];
  baseFocusOffset: number;
  onItemFocus: (offset: number) => void;
  onEpisodePlay: (episode: EpisodeType) => void;
}

const SECTION_NAME = 'EXTRA_CONTENT_SECTION';
const LIST_HEIGTH = scaleSize(675);

const itemSize = LIST_ITEMS_SIZE.LARGE.width + LIST_ITEM_MARGIN;

const LIST_CONFIG = {
  enterTo: 'last-focused',
  leaveFor: {
    right: '',
    left: '@BACK_BUTTON',
  },
};

const ExtraContentSection: React.FC<IExtraContentSection> = (props) => {
  const { seasons, recommendations, baseFocusOffset, onItemFocus, onEpisodePlay } = props;
  const history = useHistory();
  const hasSeasons = !isEmpty(seasons);

  const onRecommendationsFocus = useCallback(() => {
    const actualIndex = hasSeasons ? 1 : 0;
    const offset = baseFocusOffset + actualIndex * LIST_HEIGTH;

    onItemFocus(offset);
  }, [hasSeasons, baseFocusOffset, onItemFocus]);

  const onListItemEnter = useCallback(
    (item, index) => {
      // console.log(lastFocus);
      // // console.log(selectedItemId);
      // const selectedItemId = `recommendations-list-item-${index}`;
      // if (lastFocus) lastFocus.save(`#${selectedItemId}`);
      history.push(`/details/${item.type}/${item.id}`);
    },
    [history],
  );

  const onSeasonsFocus = useCallback(() => onItemFocus(baseFocusOffset), [
    baseFocusOffset,
    onItemFocus,
  ]);

  return (
    <FocusableParent id="details-extra-content" sectionName={SECTION_NAME}>
      {!isEmpty(seasons) && (
        <Seasons
          seasons={seasons}
          onFocus={onSeasonsFocus}
          onListItemEnter={onEpisodePlay}
          sectionName="SEASONS"
        />
      )}
      {!isEmpty(recommendations) && (
        <StyledRecommendationsList
          title="Recommendations"
          listId={'recommendations-list'}
          sectionName={'RECOMENDATIONS-LIST'}
          startScrollIndex={1}
          itemSize={itemSize}
          items={recommendations}
          onEnter={onListItemEnter}
          onFocus={onRecommendationsFocus}
          config={LIST_CONFIG}
          renderSize={10}
          itemComponent={ListItem.VOD_ASSET}
        />
      )}
    </FocusableParent>
  );
};

export default ExtraContentSection;
